import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { Skeleton } from '@/components/ui/skeleton';
import { tr } from '@/lib/locale';

import { useAuth } from './use-auth';

function AuthLoading() {
  return (
    <div
      role="status"
      aria-label={tr('common:state.loadingSession')}
      className="mx-auto max-w-md p-8"
    >
      <Skeleton className="h-64 w-full" />
    </div>
  );
}

/** Gate for authenticated-only routes (`/settings`). Bounces guests to /login. */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'idle' || status === 'loading') return <AuthLoading />;
  if (status === 'guest') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <Outlet />;
}

/** Gate for guest-only routes (`/login`, `/register`). Sends users home. */
export function RequireGuest() {
  const { status } = useAuth();

  if (status === 'idle' || status === 'loading') return <AuthLoading />;
  if (status === 'authenticated') return <Navigate to="/" replace />;
  return <Outlet />;
}
